module.exports = __webpack_public_path__ + "Flag-12.d875413d1516069c7403702c14e6403f.svg";